<template>
  <div>
    <div v-if="loading === true">
      <div class="centered">
        <a-spin />
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-12 d-inline-flex">
        <div class="col-md-4 border text-center p-2">
          <div>
            <img
              :src="product.productsParent.imageurl"
              class="img-fluid product-image"
              :alt="product.productsParent.name"
            />
          </div>
        </div>
        <div class="col-md-8 border p-2">
          <div>
            <h5>{{ product.productsParent.name }}</h5>
            <p class="text-muted">
              Product Id: {{ product.productsParent.productid }}
            </p>

            <div class="mt-3" v-html="product.productsParent.description"></div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="mt-3">
          <ul class="nav nav-tabs small">
            <li
              v-for="tab in tabData"
              :key="tab.id"
              @click="selectTab(tab.id)"
              :class="[currentTab == tab.id ? 'active' : 'li-tabs']"
            >
              {{ tab.name }}
            </li>
          </ul>
        </div>

        <div class="row mt-3">
          <div class="col-sm-12">
            <div v-for="tab in tabData" :key="tab.id">
              <div v-if="tab.id == currentTab">
                <div class="fade-all">
                  <component :is="tab.component" v-bind="tab.component" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditProductDetails from "./EditProductDetails.vue";
import UploadSmallImage from "./UploadSmallImage.vue";
import UploadLargeImage from "./UploadLargeImage.vue";
import DeleteProduct from "./DeleteProduct.vue";

export default {
  name: "EditProductForm",
  components: {
    EditProductDetails,
    UploadSmallImage,
    UploadLargeImage,
    DeleteProduct,
  },
  data() {
    return {
      prodId: this.$route.params.Id,
      loading: false,
      currentTab: 1,
      tabData: [
        {
          id: 1,
          name: "Edit Product Info",
          component: EditProductDetails,
        },
        {
          id: 2,
          name: "Upload Small Image",
          component: UploadSmallImage,
        },
        {
          id: 3,
          name: "Upload Large Image",
          component: UploadLargeImage,
        },
        {
          id: 4,
          name: "Delete Product",
          component: DeleteProduct,
        },
      ],
    };
  },
  computed: {
    product() {
      return this.$store.state.manageProducts.product;
    },
  },
  methods: {
    selectTab(selectedTab) {
      this.currentTab = selectedTab;
    },
    // onSubmit(e) {
    //   e.preventDefault();
    //   this.$store.dispatch("manageClients/addClient", this.form);
    // },
  },
  created() {
    window.scrollTo(0, 0);
    this.loading = true;
    this.$store
      .dispatch("manageProducts/fetchProductById", {
        productId: this.prodId,
      })
      .then(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
form {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
}
.nav {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-tabs {
  border-bottom: 1px solid #ddd;
  list-style: none;
}

.li-tabs {
  font-size: 95%;
  list-style: none;
  border: 1px solid transparent;
  text-decoration: none;
  color: #2980b9;
  display: inline-block;
  margin: 0px 8px 8px 0px;
  padding: 10px 15px;
  cursor: pointer;
  margin-bottom: -0.5px;
}

.li-tabs:hover {
  background-color: #eee;
}

.active {
  font-size: 95%;
  list-style: none;
  border: 1px solid #ddd;
  border-bottom: none;
  text-decoration: none;
  color: #777;
  display: inline-block;
  margin: 0px 8px 8px 0px;
  padding: 10px 15px;
  cursor: pointer;
  margin-bottom: -0.5px;
  border-radius: 4px 4px 0 0;
}

.nav-tabs {
  padding-left: 0px;
  margin: 0px;
}

form label {
  font-size: 15px;
  font-weight: bold;
}

fieldset {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 1.4em;
  margin: 0 0 1.5em 0;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.form-check {
  padding-left: 2rem;
}

legend {
  position: absolute;
  font-size: 100%;
  width: auto;
  padding: 0px 5px;
  border: none;
  margin-top: -30px;
  font-weight: bold;
  background-color: white;
}

.small {
  font-size: 90%;
}

.product-image {
  max-width: 100%;
  max-height: 350px;
  object-fit: contain;
}

.centered {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 99999;
}

.fade-all {
  animation: fade-all 0.7s ease;
}

@keyframes fade-all {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
